import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '../../api/leagues.ts';
import { claves } from '../../api/queries.ts';

export function useMyLeagues() {
  return useQuery({
    queryKey: claves.ligas(),
    queryFn: () => api.listMyLeagues(),
    select: (data) => data.leagues,
  });
}

export function useLeagueDetail(leagueId: string) {
  return useQuery({
    queryKey: claves.ligaDetalle(leagueId),
    queryFn: () => api.getLeagueDetail(leagueId),
  });
}

export function useCompetitions() {
  return useQuery({
    queryKey: claves.competiciones(),
    queryFn: () => api.listCompetitions(),
    select: (data) => data.competitions,
    // El catálogo cambia una vez por temporada: no tiene sentido volver a pedirlo.
    staleTime: 60 * 60 * 1000,
  });
}

export function useCreateLeague() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: api.createLeague,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: claves.ligas() });
    },
  });
}

export function useJoinLeague() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: api.joinLeague,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: claves.ligas() });
    },
  });
}

export function useLeaveLeague() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: api.leaveLeague,
    onSuccess: (_resultado, leagueId) => {
      // Se ELIMINA en vez de invalidar: tras salir, cualquier consulta sobre esa liga
      // responde 404, y volver a pedirla solo serviría para pintar el estado de "no
      // accesible" en una pantalla que ya estamos abandonando.
      queryClient.removeQueries({ queryKey: claves.liga(leagueId) });
      void queryClient.invalidateQueries({ queryKey: claves.ligas() });
    },
  });
}
